export enum EmailEntryFormLabelsEnum {
  SUBJECT = 'Subject',
  RECIPIENTS = 'Recipients',
  CC = 'CC',
  TEMPLATE = 'Template',
  EMAIL_CONTENT = 'Email Description',
}
